export enum ProjectType {
	TEMPLATE = "TEMPLATE",
	CUSTOM = "CUSTOM",
	NONE = ""
}